(function (global) {
  'use strict';

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (isNaN(number) || number == null) return '0';

    precision = precision == null ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';

    var numString = (number / 100.0).toFixed(precision);
    var parts = numString.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  function formatMoney(cents, formatString) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents);
    formatString = formatString || global.onsideMoneyFormat || '${{amount}}';

    return formatString.replace(placeholderRegex, function (match, placeholder) {
      switch (placeholder) {
        case 'amount':
          return formatWithDelimiters(cents, 2);
        case 'amount_no_decimals':
          return formatWithDelimiters(cents, 0);
        case 'amount_with_comma_separator':
          return formatWithDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return formatWithDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return formatWithDelimiters(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator':
          return formatWithDelimiters(cents, 0, ' ');
        case 'amount_with_space_separator':
          return formatWithDelimiters(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator':
          return formatWithDelimiters(cents, 2, ' ', '.');
        default:
          return match;
      }
    });
  }

  global.Onside = global.Onside || {};
  global.Onside.formatMoney = formatMoney;
})(typeof window !== 'undefined' ? window : this);
